/* Happy Pointer Farms — cart drawer, purchase selector, situation picker */
(function () {
  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  /* ------------- Situation picker (delegated for Theme Editor reloads) ------------- */
  function activateSituation(root, key) {
    if (!root || !key) return;

    root.querySelectorAll('[data-situation-input]').forEach(function (input) {
      input.checked = input.getAttribute('data-situation-key') === key;
    });
    root.querySelectorAll('[data-situation-option]').forEach(function (option) {
      var active = option.getAttribute('data-situation-key') === key;
      option.classList.toggle('is-active', active);
      option.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    root.querySelectorAll('[data-situation-panel]').forEach(function (panel) {
      var active = panel.getAttribute('data-situation-key') === key;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  }

  document.addEventListener('click', function (e) {
    var option = e.target.closest && e.target.closest('[data-situation-option]');
    if (!option) return;
    activateSituation(option.closest('[data-situations]'), option.getAttribute('data-situation-key'));
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-situation-input]');
    if (!input || !input.checked) return;
    activateSituation(input.closest('[data-situations]'), input.getAttribute('data-situation-key'));
  });

  /* ---------------- Cart drawer ---------------- */
  var drawer = {
    get el() { return document.querySelector('[data-cart-drawer]'); },
    get overlay() { return document.querySelector('[data-cart-overlay]'); },
    open: function () {
      var el = this.el;
      if (!el) return;
      el.classList.add('open');
      var ov = this.overlay;
      if (ov) ov.classList.add('open');
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      var el = this.el;
      if (!el) return;
      el.classList.remove('open');
      var ov = this.overlay;
      if (ov) ov.classList.remove('open');
      document.body.style.overflow = '';
    }
  };


  function purchaseLabel(item) {
    if (item.selling_plan_allocation) {
      return item.selling_plan_allocation.selling_plan.name;
    }
    var props = item.properties || {};
    if (props['Purchase type']) return props['Purchase type'];
    return 'One-time purchase';
  }

  function renderCart(cart) {
    var body = document.querySelector('[data-cart-body]');
    var foot = document.querySelector('[data-cart-subtotal]');
    var counts = document.querySelectorAll('[data-cart-count]');
    var checkout = document.querySelector('[data-cart-checkout]');
    if (!body) return;

    counts.forEach(function (n) {
      n.textContent = cart.item_count;
      n.style.display = cart.item_count > 0 ? '' : 'none';
    });

    if (!cart.items.length) {
      body.innerHTML =
        '<p class="charcoal">Your cart is empty. Hip &amp; Joint Support Advanced is in stock now.</p>';
      if (foot) foot.textContent = money(0);
      if (checkout) checkout.setAttribute('disabled', 'disabled');
      return;
    }
    if (checkout) checkout.removeAttribute('disabled');

    body.innerHTML = cart.items
      .map(function (item) {
        var img = item.image
          ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_180x$1$2') + '" alt="" width="72" height="72">'
          : '<div style="width:72px;height:72px;border-radius:6px;background:var(--secondary)"></div>';
        return (
          '<div class="cart-line" data-key="' + item.key + '">' +
          img +
          '<div>' +
          '<p class="type">' + purchaseLabel(item) + '</p>' +
          '<p style="font-family:var(--font-display);font-size:1.05rem;">' + item.product_title + '</p>' +
          '<p class="small charcoal">' + money(item.final_line_price) + '</p>' +
          '<div class="qty">' +
          '<a href="/cart/change?id=' + encodeURIComponent(item.key) + '&quantity=' + (item.quantity - 1) + '" data-qty="' + item.key + '" data-to="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</a>' +
          '<span>' + item.quantity + '</span>' +
          '<a href="/cart/change?id=' + encodeURIComponent(item.key) + '&quantity=' + (item.quantity + 1) + '" data-qty="' + item.key + '" data-to="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</a>' +
          '</div>' +
          '<br><a class="remove" href="/cart/change?id=' + encodeURIComponent(item.key) + '&quantity=0" data-qty="' + item.key + '" data-to="0">Remove</a>' +
          '</div></div>'
        );
      })
      .join('');

    if (foot) foot.textContent = money(cart.total_price);
  }

  /* Read a Shopify cart response safely: empty or non-JSON bodies must not throw
     "Unexpected end of JSON input" — surface the real status instead. */
  function safeJson(response) {
    return response.text().then(function (text) {
      var data = null;
      if (text && text.length) {
        try { data = JSON.parse(text); } catch (e) { data = null; }
      }
      if (data === null) {
        console.error('Shopify cart request failed:', response.status, response.url, text);
        var err = new Error(
          response.ok
            ? 'Shopify returned an empty response (status ' + response.status + ').'
            : 'Shopify returned status ' + response.status + ' for ' + response.url + '.'
        );
        err.emptyBody = true;
        err.status = response.status;
        err.url = response.url;
        throw err;
      }
      if (!response.ok) {
        console.error('Shopify cart request failed:', response.status, response.url, data);
        var e2 = new Error(data.description || data.message || 'Shopify returned status ' + response.status + '.');
        e2.shopifyError = true;
        e2.status = response.status;
        throw e2;
      }
      return data;
    });
  }






  function fetchCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(safeJson)
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(key, quantity) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(safeJson)
      .then(renderCart);
  }

  function addToCart(payload) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    })
      .then(safeJson)
      .then(function (res) {
        if (res.status) {
          var e = new Error(res.description || res.message || 'Could not add to cart.');
          e.shopifyError = true;
          throw e;
        }
        /* Item is in the cart. Never let a drawer/render problem look like a failure. */
        return fetchCart()
          .catch(function (err) { console.error('Cart refresh failed after add:', err); })
          .then(function () {
            try { drawer.open(); } catch (err) { console.error('Cart drawer failed to open:', err); }
          });
      });
  }


  /* ------------- Purchase form (delegated: survives Theme Editor re-renders) ------------- */
  var PURCHASE_FORM = '[data-purchase-form], form.purchase';

  function syncPurchaseForm(form) {
    form.querySelectorAll('[data-purchase-option]').forEach(function (opt) {
      var input = opt.querySelector('input[type="radio"]');
      opt.classList.toggle('selected', !!(input && input.checked));
    });
    var checked = form.querySelector('input[name="purchase_type"]:checked');
    if (!checked) return;
    var plan = checked.getAttribute('data-selling-plan') || '';
    var planField = form.querySelector('[name="selling_plan"]');
    if (planField) planField.value = plan;
    var propField = form.querySelector('[data-purchase-property]');
    if (propField) {
      propField.value = checked.getAttribute('data-label') || '';
      propField.disabled = !!plan; /* selling plan already labels the line */
    }
  }

  function showFormError(form, message) {
    var box = form.querySelector('[data-purchase-error]');
    if (!box) {
      box = document.createElement('p');
      box.className = 'notice mt-3';
      box.setAttribute('data-purchase-error', '');
      form.appendChild(box);
    }
    box.textContent = message;
    box.hidden = false;
  }

  function clearFormError(form) {
    var box = form.querySelector('[data-purchase-error]');
    if (box) box.hidden = true;
  }

  function syncAllPurchaseForms() {
    document.querySelectorAll(PURCHASE_FORM).forEach(syncPurchaseForm);
  }

  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest(PURCHASE_FORM);
    if (form) syncPurchaseForm(form);
  });

  /* The buy box is a native Shopify product form. JavaScript only enhances it:
     if the in-page AJAX add works we open the drawer, otherwise the browser
     submits the form normally and Shopify adds the item and shows /cart. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest(PURCHASE_FORM);
    if (!form) return;
    if (form.hasAttribute('data-native-submit')) return; /* let the browser post it */
    e.preventDefault();
    clearFormError(form);
    syncPurchaseForm(form);

    var btn = form.querySelector('[data-add-button]') || form.querySelector('button[type="submit"]');
    var original = btn ? btn.textContent : '';
    var restore = function () {
      if (!btn) return;
      btn.removeAttribute('disabled');
      btn.textContent = original;
    };
    if (btn) { btn.setAttribute('disabled', 'disabled'); btn.textContent = 'Adding…'; }

    var formData = new FormData(form);
    var variantId = formData.get('id');
    if (!variantId) {
      restore();
      showFormError(form, 'No product variant is connected yet. Choose the hero product in Theme settings → Product and publish it to the Online Store sales channel.');
      return;
    }

    var payload = { items: [{ id: variantId, quantity: 1, properties: {} }] };
    var plan = formData.get('selling_plan');
    if (plan) payload.items[0].selling_plan = plan;
    var label = formData.get('properties[Purchase type]');
    if (label) payload.items[0].properties['Purchase type'] = label;

    var settled = false;
    /* Anything other than a clean in-page add falls back to the plain form post. */
    var nativeSubmit = function () {
      if (settled) return;
      settled = true;
      form.setAttribute('data-native-submit', 'true');
      if (btn) btn.textContent = 'Adding…';
      form.submit();
    };
    var guard = window.setTimeout(nativeSubmit, 6000);

    Promise.resolve()
      .then(function () { return addToCart(payload); })
      .then(function () {
        window.clearTimeout(guard);
        if (settled) return;
        settled = true;
        restore();
      })
      .catch(function (err) {
        window.clearTimeout(guard);
        console.error('Add to cart failed, falling back to form submit:', err);
        if (err && err.shopifyError && err.message) {
          /* A real Shopify rejection (sold out, invalid variant) — show it. */
          settled = true;
          restore();
          showFormError(form, err.message);
          return;
        }
        nativeSubmit();
      });
  });


  document.addEventListener('shopify:section:load', syncAllPurchaseForms);

  document.addEventListener('DOMContentLoaded', function () {


    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-cart-open]');
      if (openBtn) { e.preventDefault(); drawer.open(); fetchCart(); return; }

      if (e.target.closest('[data-cart-close]') || e.target.matches('[data-cart-overlay]')) {
        drawer.close();
        return;
      }

      var qtyBtn = e.target.closest('[data-qty]');
      if (qtyBtn) {
        e.preventDefault(); /* try the fast in-page update first */
        changeLine(qtyBtn.getAttribute('data-qty'), parseInt(qtyBtn.getAttribute('data-to'), 10))
          .catch(function (err) {
            /* Any failure (blocked endpoint, expired cart, network) — follow the
               plain link so Shopify applies the change and reloads the page. */
            console.error('Cart update failed, following native link:', err);
            window.location.href = qtyBtn.href;
          });
        return;
      }


      var burger = e.target.closest('[data-menu-toggle]');
      if (burger) {
        var nav = document.querySelector('[data-mobile-nav]');
        if (nav) nav.classList.toggle('open');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') drawer.close();
    });

    syncAllPurchaseForms();


    fetchCart().catch(function (err) { console.error('Cart load failed:', err); });

  });
})();
